var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('SectionCard',{attrs:{"label":"Оценка проведения инспекции"}},[_c('div',{staticClass:"mb-2"},[_c('VRating',{attrs:{"color":"primary","readonly":"","value":_vm.ratingValue}})],1),(_vm.comment)?_c('Comment',{attrs:{"date":_vm.date,"author":_vm.author,"message":_vm.comment}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }